<form mat-dialog-content class="login-form" [formGroup]="loginForm">
  <div *ngIf="!passwordForgotten">
    <div class="letrot-form-field">
      <mat-label>{{ "auth.fields.email" | translate }}</mat-label>
      <input class="letrot__input" formControlName="email" autocomplete="username" />
    </div>
    <div class="letrot-form-field">
      <mat-label>{{ "auth.fields.password" | translate }}</mat-label>
      <input class="letrot__input" formControlName="password" type="password" autocomplete="current-password" />
    </div>
    <p style="color: red" *ngIf="error">Wrong email or password</p>
    <button mat-button (click)="passwordForgotten = true">Mot de passe oublié ?</button>
  </div>

  <div *ngIf="passwordForgotten && !emailSent && !emailError">
    <div class="letrot-form-field">
      <mat-label>{{ "auth.fields.email" | translate }}</mat-label>
      <input class="letrot__input" formControlName="email" autocomplete="username" />
    </div>
    <button mat-button (click)="sendResetEmail()" class="actions__reset">Recevoir email de réinitialisation</button>
    <button mat-button (click)="retour()">Retour</button>
  </div>

  <div *ngIf="passwordForgotten && emailSent">
    <section class="section">Un email avec un lien de réinitialisation de mot de passe vous a été envoyé. </section>
    <button mat-button (click)="retour()">Retour</button>
  </div>

  <div *ngIf="passwordForgotten && emailError">
    <section class="section">Email non trouvé. veuillez vérifier votre adresse saisie. </section>
    <button mat-button (click)="retour()">Retour</button>
  </div>
</form>
